import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

const zhCNMessages = {
  "edu.pages.teachingPlans.title": "教学计划",
  "edu.pages.teachingPlans.subtitle": "这里承接教学计划的正式治理工作面：计划列表、执行边界、成员分组、作业批改和执行统计都在这个独立业务入口内完成。",
  "edu.pages.teachingPlans.notice": "教学计划页应保持正式后台列表形态：主列表走后端分页，详情与执行工作区继续留在右侧和下方。",
  "edu.pages.teachingPlans.labels.focusItems": "当前关注",
  "edu.pages.teachingPlans.labels.currentDetail": "当前计划详情",
  "edu.pages.teachingPlans.labels.memberGroups": "学员执行分组",
  "edu.pages.teachingPlans.labels.boardThreads": "留言板主题",
  "edu.pages.teachingPlans.labels.statistics": "执行统计",
  "edu.pages.teachingPlans.labels.submissions": "作业提交与批改",
  "edu.pages.teachingPlans.labels.executionCatalog": "执行目录",
  "edu.pages.teachingPlans.labels.executionBoundary": "执行边界",
  "edu.pages.teachingPlans.labels.selectionRule": "选人规则",
  "edu.pages.teachingPlans.labels.progression": "学习推进",
  "edu.pages.teachingPlans.labels.recordBoundary": "记录边界",
  "edu.pages.teachingPlans.labels.snapshotCatalog": "执行目录快照",
  "edu.pages.teachingPlans.labels.taskType": "任务类型",
  "edu.pages.teachingPlans.labels.ksaRelation": "KSA 关联",
  "edu.pages.teachingPlans.labels.courseSnapshot": "课程快照",
  "edu.pages.teachingPlans.labels.owner": "发起人",
  "edu.pages.teachingPlans.labels.learners": "学员",
  "edu.pages.teachingPlans.labels.assistants": "助教",
  "edu.pages.teachingPlans.labels.snapshotBoundary": "快照边界",
  "edu.pages.teachingPlans.labels.interactionSpace": "互动空间",
  "edu.pages.teachingPlans.labels.assistantScope": "助教范围",
  "edu.pages.teachingPlans.labels.adjustmentBoundary": "调整边界",
  "edu.pages.teachingPlans.labels.historySemantics": "历史语义",
  "edu.pages.teachingPlans.labels.learnerName": "学员",
  "edu.pages.teachingPlans.labels.assignmentTask": "作业任务",
  "edu.pages.teachingPlans.labels.summary": "摘要",
  "edu.pages.teachingPlans.labels.submittedAt": "提交时间",
  "edu.pages.teachingPlans.labels.submissionContent": "提交内容",
  "edu.pages.teachingPlans.labels.score": "分数",
  "edu.pages.teachingPlans.labels.feedback": "反馈",
  "edu.pages.teachingPlans.labels.sourceCourse": "来源课程",
  "edu.pages.teachingPlans.labels.planTitle": "计划标题",
  "edu.pages.teachingPlans.labels.progressionMode": "推进方式",
  "edu.pages.teachingPlans.labels.planDescription": "计划说明",
  "edu.pages.teachingPlans.labels.plan": "教学计划",
  "edu.pages.teachingPlans.labels.planDraft": "计划草稿",
  "edu.pages.teachingPlans.labels.lifecycle": "生命周期",
  "edu.pages.teachingPlans.labels.learnersShort": "学员",
  "edu.pages.teachingPlans.labels.assistantsShort": "助教",
  "edu.pages.teachingPlans.labels.progressShort": "当前进度",
  "edu.pages.teachingPlans.labels.round": "第 {value} 轮学习",
  "edu.pages.teachingPlans.labels.requiredLessonProgressSummary": "{completed}/{total} 个必修课时",
  "edu.pages.teachingPlans.labels.taskProgressSummary": "{completed}/{total} 个可手动任务",
  "edu.pages.teachingPlans.labels.assignmentSubmittedSummary": "已提交 {count} 条",
  "edu.pages.teachingPlans.labels.assignmentPendingSummary": "待批改 {count} 条",
  "edu.pages.teachingPlans.labels.assignmentReviewedSummary": "已批改 {count} 条",
  "edu.pages.teachingPlans.labels.snapshotChapterCount": "章节",
  "edu.pages.teachingPlans.labels.snapshotLessonCount": "课时",
  "edu.pages.teachingPlans.labels.snapshotRequiredLessonCount": "必修课时",
  "edu.pages.teachingPlans.labels.snapshotTaskCount": "教学任务",
  "edu.pages.teachingPlans.labels.adjustmentTrace": "调整记录",
  "edu.pages.teachingPlans.labels.currentActions": "当前执行动作",
  "edu.pages.teachingPlans.messages.emptyGroup": "当前分组暂无成员。",
  "edu.pages.teachingPlans.messages.taskSubmissionsLoadFailed": "作业提交列表加载失败。",
  "edu.pages.teachingPlans.messages.boardThreadsLoadFailed": "留言主题加载失败。",
  "edu.pages.teachingPlans.messages.statisticsLoadFailed": "教学计划执行统计加载失败",
  "edu.pages.teachingPlans.messages.pendingReview": "等待教员或助教批改",
  "edu.pages.teachingPlans.messages.snapshotFrozenDescription": "教学计划创建时冻结的课程方案目录；源课程调整不会自动改写这份执行目录。",
  "edu.pages.teachingPlans.messages.statisticsEmptyTitle": "请选择一个教学计划查看执行统计。",
  "edu.pages.teachingPlans.messages.statisticsGeneratedDescription": "生成时间：{value}。必修课时与可手动教学任务完成按共享课程学习事实投影；作业提交、待批改、已批改按当前教学计划隔离统计。",
  "edu.pages.teachingPlans.messages.statisticsSwitchDescription": "统计口径会随教学计划切换自动刷新。",
  "edu.pages.teachingPlans.messages.emptyDraftStatistics": "草稿计划暂无执行统计。",
  "edu.pages.teachingPlans.messages.emptyStatistics": "当前计划暂无学员统计。",
  "edu.pages.teachingPlans.messages.draftSubmissionsSummary": "草稿计划发布后才会产生作业提交。",
  "edu.pages.teachingPlans.messages.emptySubmissionsSummary": "请选择一个教学计划查看作业提交。",
  "edu.pages.teachingPlans.messages.emptyThreadsSummary": "请选择一个教学计划查看留言主题。",
  "edu.pages.teachingPlans.messages.publishFailed": "教学计划发布失败",
  "edu.pages.teachingPlans.messages.endFailed": "教学计划结束失败",
  "edu.pages.teachingPlans.messages.resetFailed": "学习重置失败",
  "edu.pages.teachingPlans.messages.bulkResetFailed": "批量重置学习失败",
  "edu.pages.teachingPlans.messages.loadFailed": "教学计划加载失败",
  "edu.pages.teachingPlans.messages.detailLoadFailed": "教学计划详情加载失败",
  "edu.pages.teachingPlans.messages.boardThreadsDescription": "当前教学计划留言板按主题摘要留痕：老师或助教发起主题，学员端留言板 TAB 会读取同一批真实主题摘要。",
  "edu.pages.teachingPlans.messages.emptyBoardThreads": "当前计划还没有留言主题。",
  "edu.pages.teachingPlans.messages.threadTrace": "主题会进入教学计划真实留痕",
  "edu.pages.teachingPlans.messages.threadTraceDescription": "学员在教学计划学习入口的留言板 TAB 会读取这些主题摘要；这里当前只维护主题摘要留痕。",
  "edu.pages.teachingPlans.messages.noticeTrace": "通知会进入教学计划真实留痕",
  "edu.pages.teachingPlans.messages.noticeTraceDescription": "学员在教学计划学习入口和任务焦点页都会看到同一份计划通知留痕；这一步不扩消息中心重构。",
  "edu.pages.teachingPlans.messages.createDraftOnly": "当前只创建教学计划草稿",
  "edu.pages.teachingPlans.messages.createDraftOnlyDescription": "这一步会先写入一份基于课程创建的教学计划草稿；成员绑定、助教配置、发布、通知、学习记录和作业考试结果都继续围绕这份计划管理。",
  "edu.pages.teachingPlans.messages.memberScope": "成员来自 edu 本地成员范围",
  "edu.pages.teachingPlans.messages.memberScopeDescription": "这里绑定的是具体人；组织树只作为批量选人和筛选包装，不替代教学计划里的成员关系。保存后会更新计划成员与助教计数，但不会发布计划，也不会生成学习记录。",
  "edu.pages.teachingPlans.messages.editSnapshotOnly": "这里只调整当前教学计划的执行快照",
  "edu.pages.teachingPlans.messages.editSnapshotOnlyDescription": "保存后会立即影响当前计划的新学习目录；源课程不会被回写，历史提交和历史结果仍按发生时的旧快照节点解释。",
  "edu.pages.teachingPlans.messages.submissionsDescription": "当前只治理单课程教学计划内 assignment/homework 任务的文本提交；已结束计划仍可批改历史提交，学员侧不会再产生新提交。",
  "edu.pages.teachingPlans.messages.emptyDraftSubmissions": "草稿计划暂无作业提交。",
  "edu.pages.teachingPlans.messages.emptySubmissions": "当前计划暂无作业提交。",
  "edu.pages.teachingPlans.messages.threadCreateFailed": "留言主题发布失败",
  "edu.pages.teachingPlans.messages.noticeCreateFailed": "教学计划通知发送失败",
  "edu.pages.teachingPlans.messages.reviewSaveFailed": "作业批改保存失败",
  "edu.pages.teachingPlans.messages.createFailed": "教学计划创建失败",
  "edu.pages.teachingPlans.messages.memberConfigFailed": "教学计划成员配置失败",
  "edu.pages.teachingPlans.messages.catalogSaveFailed": "教学计划执行目录保存失败",
  "edu.pages.teachingPlans.placeholders.emptyDetail": "请选择一个教学计划查看详情。",
  "edu.pages.teachingPlans.placeholders.createCourseRequired": "请选择来源课程",
  "edu.pages.teachingPlans.placeholders.createCoursePlaceholder": "从课程中心查找带回一门真实课程",
  "edu.pages.teachingPlans.placeholders.emptyCoursePicker": "当前没有可供带回的课程。",
  "edu.pages.teachingPlans.placeholders.emptyMemberPicker": "当前没有可供带回的成员。",
  "edu.pages.teachingPlans.placeholders.learnerPickerPlaceholder": "查找带回应学学员",
  "edu.pages.teachingPlans.placeholders.assistantPickerPlaceholder": "查找带回助教成员",
  "edu.pages.teachingPlans.placeholders.threadTitlePlaceholder": "例如：本周案例讨论入口",
  "edu.pages.teachingPlans.placeholders.noticeTitlePlaceholder": "例如：本周课堂安排调整",
  "edu.pages.teachingPlans.placeholders.summaryPlaceholder": "给学员看到的简短摘要，可留空。",
  "edu.pages.teachingPlans.placeholders.threadContentPlaceholder": "写下本次教学计划主题的详细内容。",
  "edu.pages.teachingPlans.placeholders.noticeContentPlaceholder": "写下本次教学计划通知的详细内容。",
  "edu.pages.teachingPlans.placeholders.reviewScorePlaceholder": "可留空，仅给反馈",
  "edu.pages.teachingPlans.placeholders.reviewFeedbackPlaceholder": "写下给学员的批改反馈。",
  "edu.pages.teachingPlans.placeholders.planTitlePlaceholder": "例如：2026 网络安全新员工第一期",
  "edu.pages.teachingPlans.placeholders.planDescriptionPlaceholder": "先写下本轮教学计划的对象、安排或执行说明。",
  "edu.pages.teachingPlans.placeholders.ksaPlaceholder": "输入 KSA key 后回车",
  "edu.pages.teachingPlans.labels.chapterAndLesson": "章节与课时",
  "edu.pages.teachingPlans.labels.lessons": "课时",
  "edu.pages.teachingPlans.labels.tasks": "教学任务",
  "edu.pages.teachingPlans.labels.draftResetDisabled": "草稿不可重置",
  "edu.pages.teachingPlans.confirm.deleteChapterTitle": "删除章节",
  "edu.pages.teachingPlans.confirm.deleteChapterDescription": "确认删除章节 {index} 吗？其下课时与教学任务会一并移除。",
  "edu.pages.teachingPlans.confirm.deleteLessonTitle": "删除课时",
  "edu.pages.teachingPlans.confirm.deleteLessonDescription": "确认删除课时 {index} 吗？其下教学任务会一并移除。",
  "edu.pages.teachingPlans.confirm.deleteTaskTitle": "删除教学任务",
  "edu.pages.teachingPlans.confirm.deleteTaskDescription": "确认删除该教学任务吗？此操作不会保留当前表单中的任务内容。",
  "edu.pages.teachingPlans.confirm.resetLearnerTitle": "重置该学员的课程学习",
  "edu.pages.teachingPlans.confirm.resetLearnerDescription": "会保留旧轮次事实作为历史，并生成新的正式学习轮次；当前统计按最新轮次刷新。",
  "edu.pages.teachingPlans.confirm.bulkResetTitle": "批量重置选中学员的课程学习",
  "edu.pages.teachingPlans.confirm.bulkResetDescription": "会逐个保留旧轮次事实作为历史，并为可重置学员生成新的正式学习轮次；失败项会在接口结果中逐项返回。",
  "edu.pages.teachingPlans.confirm.publishTitle": "发布教学计划",
  "edu.pages.teachingPlans.confirm.publishDescription": "发布后学员端才能看到该教学计划；系统会自动留下一条计划发布通知，但不会自动创建学习记录。",
  "edu.pages.teachingPlans.confirm.endTitle": "结束教学计划",
  "edu.pages.teachingPlans.confirm.endDescription": "结束后计划进入历史回看语义，当前不再产生新的教学执行推进。",
  "edu.pages.teachingPlans.modals.threadTitle": "发起留言主题",
  "edu.pages.teachingPlans.modals.noticeTitle": "发送教学计划通知",
  "edu.pages.teachingPlans.modals.reviewTitle": "批改作业提交",
  "edu.pages.teachingPlans.modals.createTitle": "新建教学计划",
  "edu.pages.teachingPlans.modals.memberTitle": "配置教学计划成员",
  "edu.pages.teachingPlans.modals.coursePickerTitle": "选择来源课程",
  "edu.pages.teachingPlans.modals.learnerPickerTitle": "选择学员",
  "edu.pages.teachingPlans.modals.assistantPickerTitle": "选择助教",
  "edu.pages.teachingPlans.actions.refreshThreads": "刷新主题",
  "edu.pages.teachingPlans.actions.refreshStatistics": "刷新统计",
  "edu.pages.teachingPlans.actions.refreshSubmissions": "刷新提交",
  "edu.pages.teachingPlans.actions.publish": "发布",
  "edu.pages.teachingPlans.actions.end": "结束",
  "edu.pages.teachingPlans.actions.configureMembers": "配置成员",
  "edu.pages.teachingPlans.actions.createThread": "发起留言主题",
  "edu.pages.teachingPlans.actions.sendNotice": "发送通知",
  "edu.pages.teachingPlans.actions.publishPlan": "发布计划",
  "edu.pages.teachingPlans.actions.endPlan": "结束计划",
  "edu.pages.teachingPlans.actions.resetLearning": "重置学习",
  "edu.pages.teachingPlans.actions.bulkReset": "批量重置",
  "edu.pages.teachingPlans.actions.bulkResetLearning": "批量重置学习",
  "edu.pages.teachingPlans.actions.review": "批改",
  "edu.pages.teachingPlans.actions.saveReview": "保存批改",
  "edu.pages.teachingPlans.actions.pick": "查找带回",
  "edu.pages.teachingPlans.actions.clear": "清空",
  "edu.pages.teachingPlans.actions.submitPickedCourse": "带回已选课程",
  "edu.pages.teachingPlans.actions.submitPickedLearner": "带回已选学员",
  "edu.pages.teachingPlans.actions.submitPickedAssistant": "带回已选助教",
  "edu.pages.teachingPlans.actions.deleteChapter": "删除章节",
  "edu.pages.teachingPlans.actions.deleteLesson": "删除课时",
  "edu.pages.teachingPlans.actions.saveMembers": "保存成员",
  "edu.pages.teachingPlans.actions.saveCatalog": "保存执行目录",
  "edu.pages.teachingPlans.forms.threadTitleLabel": "主题标题",
  "edu.pages.teachingPlans.forms.threadTitleRequired": "请输入主题标题",
  "edu.pages.teachingPlans.forms.threadTitleMax": "主题标题不能超过 128 个字符",
  "edu.pages.teachingPlans.forms.threadSummaryLabel": "主题摘要",
  "edu.pages.teachingPlans.forms.threadSummaryMax": "主题摘要不能超过 256 个字符",
  "edu.pages.teachingPlans.forms.threadContentLabel": "主题正文",
  "edu.pages.teachingPlans.forms.threadContentRequired": "请输入主题正文",
  "edu.pages.teachingPlans.forms.threadContentMax": "主题正文不能超过 4000 个字符",
  "edu.pages.teachingPlans.forms.noticeTitleLabel": "通知标题",
  "edu.pages.teachingPlans.forms.noticeTitleRequired": "请输入通知标题",
  "edu.pages.teachingPlans.forms.noticeTitleMax": "通知标题不能超过 128 个字符",
  "edu.pages.teachingPlans.forms.noticeSummaryLabel": "通知摘要",
  "edu.pages.teachingPlans.forms.noticeSummaryMax": "通知摘要不能超过 256 个字符",
  "edu.pages.teachingPlans.forms.noticeContentLabel": "通知正文",
  "edu.pages.teachingPlans.forms.noticeContentRequired": "请输入通知正文",
  "edu.pages.teachingPlans.forms.noticeContentMax": "通知正文不能超过 4000 个字符",
  "edu.pages.teachingPlans.forms.scoreRange": "分数范围为 0-100",
  "edu.pages.teachingPlans.forms.feedbackMax": "反馈不能超过 2000 个字符",
  "edu.pages.teachingPlans.forms.planTitleRequired": "请输入教学计划标题",
  "edu.pages.teachingPlans.forms.planTitleMax": "教学计划标题不能超过 128 个字符",
  "edu.pages.teachingPlans.forms.progressionModeRequired": "请选择推进方式",
  "edu.pages.teachingPlans.forms.planDescriptionMax": "计划说明不能超过 512 个字符",
  "edu.pages.teachingPlans.forms.memberConflict": "同一个成员不能同时作为学员和助教。",
  "edu.pages.teachingPlans.forms.catalogTitleLabel": "目录标题",
  "edu.pages.teachingPlans.forms.catalogTitleRequired": "请输入目录标题",
  "edu.pages.teachingPlans.forms.catalogSummaryLabel": "目录说明",
  "edu.pages.teachingPlans.forms.catalogKsaLabel": "目录 KSA 目标",
  "edu.pages.teachingPlans.forms.chapterTitleLabel": "章节标题",
  "edu.pages.teachingPlans.forms.chapterTitleRequired": "请输入章节标题",
  "edu.pages.teachingPlans.forms.chapterKindLabel": "章节性质",
  "edu.pages.teachingPlans.forms.chapterSummaryLabel": "章节说明",
  "edu.pages.teachingPlans.forms.chapterKsaLabel": "章节 KSA 目标",
  "edu.pages.teachingPlans.forms.lessonTitleLabel": "课时标题",
  "edu.pages.teachingPlans.forms.lessonTitleRequired": "请输入课时标题",
  "edu.pages.teachingPlans.forms.lessonTypeLabel": "课时类型",
  "edu.pages.teachingPlans.forms.lessonCompletionKindLabel": "完成性质",
  "edu.pages.teachingPlans.forms.lessonStageSummaryLabel": "阶段说明",
  "edu.pages.teachingPlans.forms.lessonStageSummaryRequired": "请输入阶段说明",
  "edu.pages.teachingPlans.forms.lessonUnlockRuleLabel": "解锁规则",
  "edu.pages.teachingPlans.forms.lessonUnlockRuleRequired": "请输入解锁规则",
  "edu.pages.teachingPlans.forms.lessonKsaLabel": "课时 KSA 目标",
  "edu.pages.teachingPlans.forms.taskTitleLabel": "任务标题",
  "edu.pages.teachingPlans.forms.taskTitleRequired": "请输入任务标题",
  "edu.pages.teachingPlans.forms.taskTypeLabel": "任务类型",
  "edu.pages.teachingPlans.forms.taskStageLabel": "阶段",
  "edu.pages.teachingPlans.forms.taskActionsLabel": "操作",
  "edu.pages.teachingPlans.forms.taskCompletionTemplateLabel": "完成条件模板",
  "edu.pages.teachingPlans.forms.taskCompletionTemplateRequired": "请选择完成条件模板",
  "edu.pages.teachingPlans.forms.taskKsaLabel": "任务 KSA 目标",
} satisfies MessageTree;

export const eduTeachingPlansPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": zhCNMessages,
  en: zhCNMessages,
  ja: zhCNMessages,
};
